/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';

export default class ApiErrorSummary extends Model {
  @attr('boolean') declare hasRecentError: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'standalone/api-error-summary': ApiErrorSummary;
  }
}
